module.exports = __webpack_public_path__ + "img/wp-hosting.aeb25789.svg";